import React from "react";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ReactPlaceholder from "react-placeholder";
import "react-placeholder/lib/reactPlaceholder.css";

// you can use this component for rendering the categories whereever you want

const AllCategories = ({
  categories,
  categoryLoading,
  setSearchProduct,
  setShowList,
  showList,
}) => {
  const navigate = useNavigate();

  return (
    <Col lg={3}>
      <aside>
        <div className="divider"></div>
        <ul className="p-0 ps-md-3">
          <ReactPlaceholder
            type="text"
            color="#F0F0F0"
            showLoadingAnimation
            rows={5}
            ready={!categoryLoading}
          >
            {categories?.map((category) => (
              <>
                <li
                  onClick={() => {
                    setSearchProduct("");
                    setShowList(!showList);
                    navigate(`/shop/${category?._id}`);
                  }}
                  key={category?._id}
                  className="side-link"
                >
                  <span>{category?.name}</span>
                </li>
              </>
            ))}
          </ReactPlaceholder>
        </ul>
      </aside>
    </Col>
  );
};

export default AllCategories;
